import { useActualIncidentId } from '../commonHooks';
import { queryOptions, useQuery } from '@tanstack/react-query';
import { IncidentRoster } from './incidentRoster.types';
import { incidentRosterKeys } from './incidentRoster.queryKeys';
import axios from 'axios';
import config from '../../../../constants/apiConfig';

export const getIncidentRoster = async (incidentId: string) => {
  const response = await axios<IncidentRoster>(
    config.apiGateway.getRosterForIncident,
    {
      method: 'POST',
      data: {
        incident_id: incidentId,
      },
    }
  );
  return response.data ?? [];
};

export const incidentRosterQueryOptions = (incidentId: string) =>
  queryOptions({
    queryKey: incidentRosterKeys.byIncident(incidentId),
    queryFn: () => getIncidentRoster(incidentId),
    enabled: !!incidentId,
  });

export const useIncidentRoster = <TData = IncidentRoster>(
  select?: (data: IncidentRoster) => TData
) => {
  const incidentId = useActualIncidentId();

  return useQuery({
    ...incidentRosterQueryOptions(incidentId),
    select,
  });
};
